var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"success-page",style:({backgroundImage: 'url(' + _vm.bannerImg + ')'})},[_c('img',{staticClass:"use",attrs:{"src":require("@/assets/img/coupon/use.png"),"alt":"领取成功"},on:{"click":_vm.useConpon}})])}
var staticRenderFns = []

export { render, staticRenderFns }